import * as React from 'react'
import { connect } from 'react-redux'
import { BillingBillsListComponent } from './BillingBillsList'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'
import showPayWithCreditCardFormModal from 'features/Billing/PayWithCreditCardFormModal'
import showCasesCreateBillingDisputeModal from 'features/Cases/CasesCreateBillingDisputeModal'
import showCasesCreateEnquiryModal from 'features/Cases/CasesCreateEnquiryModal'

const form = 'BillingBillsList'

export interface IBillingBillsListContainerProps {
  page: number
  ban?: string
}

const stateToProps = ({ billing }, { ban }: IBillingBillsListContainerProps) => ({
  banOptions: [
    { name: 'Any', value: '' },
    ...billing.billingAccounts.map(account => ({
      name: `${account.ban} - ${account.name}`,
      value: account.ban,
    })),
  ],
  initialValues: {
    ban,
  },
})

export const dispatchToProps = {
  replace,
  showPayWithCreditCardFormModal,
  showCasesCreateBillingDisputeModal,
  showCasesCreateEnquiryModal,
}

export const BillingBillsList = flow<any, any, React.SFC<IBillingBillsListContainerProps>>(
  reduxForm({ form, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(BillingBillsListComponent)



// WEBPACK FOOTER //
// src/features/BillingBills/BillingBillsList/BillingBillsList.container.ts